import './Subiecte.css';

export default function Subiecte2016() {
    return (
        <div className="container my-4">
            <h2 className="fw-bold mb-4 subjectTitle">{'<'}Subiecte 2016{'/>'}</h2>
            <div className="mb-4">
                <h5>1. <strong>August</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2016/SubiectAugust2016MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2016/SubiectAugust2016MIPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2016/BaremAugust2016MI.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2016/SubiectAugust2016SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2016/SubiectAugust2016SNPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2016/BaremAugust2016SN.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="mb-4">
                <h5>2. <strong>Iunie</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2016/SubiectIunie2016MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2016/SubiectIunie2016MIPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2016/BaremIunie2016MI.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2016/SubiectIunie2016SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2016/SubiectIunie2016SNPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2016/BaremIunie2016SN.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="mb-4">
                <h5>3. <strong>Sesiunea Specială</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2016/SubiectSpeciala2016MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2016/SubiectSpeciala2016MIPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2016/BaremSpeciala2016MI.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2016/SubiectSpeciala2016SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>
                            </li>
                            <li>
                                <a href="/subiecte/2016/BaremSpeciala2016SN.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="mb-4">
                <h5>4. <strong>Simulare</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2016/SubiectSimulare2016MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2016/SubiectSimulare2016MIPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2016/BaremSimulare2016MI.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2016/SubiectSimulare2016SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2016/SubiectSimulare2016SNPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2016/BaremSimulare2016SN.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="mb-4">
                <h5>5. <strong>Model</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2016/SubiectModel2016MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2016/SubiectModel2016MIPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2016/BaremModel2016MI.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2016/SubiectModel2016SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2016/SubiectModel2016SNPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2016/BaremModel2016SN.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    );
}